var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPintopic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.266 4.026a1.386 1.386 0 012.22-.36l3.848 3.848a1.386 1.386 0 01-.36 2.22l-4.428 2.214c-.37.184-.656.502-.801.89l-1.078 2.875-5.38-5.38 2.876-1.078c.387-.145.705-.431.89-.801l2.213-4.428zm3.11-1.25a2.646 2.646 0 00-4.237.687L6.926 7.891a.378.378 0 01-.206.184L3.808 9.167a1.235 1.235 0 00-.44 2.03l2.273 2.271-3.456 3.457a.63.63 0 00.89.89l3.457-3.456 2.272 2.272a1.235 1.235 0 002.029-.44l1.092-2.911c.033-.09.1-.163.184-.205l4.428-2.214a2.646 2.646 0 00.688-4.238l-3.848-3.848z",
    fill: "var(--icon-dark-gray)"
  })));
}
export default SvgPintopic;